import type { Timestamp } from 'firebase/firestore'
import type { Role } from './user'

export const UPLOAD_CONTENT_TYPES = ['image/jpeg', 'image/png', 'application/pdf'] as const
export type UploadContentType = (typeof UPLOAD_CONTENT_TYPES)[number]

/** Proof-of-Product additionally accepts video. */
export const PROOF_VIDEO_TYPES = ['video/mp4', 'video/quicktime', 'video/webm'] as const

/** Where a proof photo's location came from. */
export type LocationSource = 'device' | 'exif'

/** GPS + capture metadata for a proof-of-product photo/video. */
export interface ProofMetadata {
  gps: { lat: number; lng: number } | null
  /** ISO timestamp the photo was captured (EXIF DateTimeOriginal), if present. */
  takenAt: string | null
  /** Camera make + model, if present. */
  camera: string | null
  /** 'device' = live Geolocation API at capture; 'exif' = embedded in the image. */
  locationSource?: LocationSource | null
}

/** Firestore `projects/{projectId}/files/{fileId}` document (blueprint §4.1). */
export interface FileDoc {
  stage: number
  fileName: string
  storagePath: string
  contentType: string
  size: number
  uploadedByUid: string
  uploadedByName: string
  uploadedByRole: Role
  uploadedAt: Timestamp
  // Proof-of-Product metadata (photos only); absent on document uploads.
  gps?: { lat: number; lng: number } | null
  takenAt?: string | null
  camera?: string | null
  locationSource?: LocationSource | null
  /** Set by the server after re-extracting EXIF from the uploaded bytes. */
  serverVerified?: boolean
}
